import { Component, Input, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { SessionSetting, AppHttp, Messages } from 'app/app.service';

import * as Rx from 'rxjs/Rx';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ChangePWComponent } from "app/pf.main/changepw/changepw.component";

declare var $: any;

@Component({
  selector: 'app-user-manger-edit',
  templateUrl: './usermangeredit.component.html',
  styleUrls: ['./usermangeredit.component.css']
})

export class UserMangerEditComponent implements OnInit {


  @Input() public formId = 'form';
  @ViewChild('modal') public lgModal: ElementRef;
  @ViewChild('pwd') changePW: ChangePWComponent;
  
  @Output() finish = new EventEmitter<any>();

  check = {
    rules: {
      USER_ID: { required: true, email: true, maxlength: 64 },
      USER_DISPLAY_NAME: { required: true, maxlength: 128 },
      USER_NAME_KANA: { katakana: true, maxlength: 128 },
      USER_NAME_KANJI: { kanji: true, maxlength: 128 },
      USER_NAME_ROMA: { pattern: '^[a-z ]+$', maxlength: 128 },
      MAIL: { email: true, maxlength: 64, equalTo: `#${this.formId}USER_ID` },
      MOBILE_MAIL: { email: true, maxlength: 64 },
      TELEPHONE_NUMBER: { phoneJP: true, maxlength: 32 },
      MOBILE_NUMBER: { mobileJP: true, maxlength: 32 },
      FAX_NUMBER: { phoneJP: true, maxlength: 32 },
      ZIP_CODE: { digits: true, maxlength: 7 },
      START_DATE: { date_yyyy_MM_dd: true, dateLessEqualTo: `#${this.formId}END_DATE` },
      END_DATE: { date_yyyy_MM_dd: true },
      USER_PASSWORD: { required: true, pwd: true, minlength: 8, maxlength: 32 },
      USER_PASSWORD_CONFIRM: { required: true, pwd: true, minlength: 8, maxlength: 32, equalTo: `#${this.formId}USER_PASSWORD` },
      COMPANY_NAME: { maxlength: 64 }
    }
  };
  domain = '';
  userId = '';
  user: any = {
    ADDRESS: '',
    COMPANY_ID: '',
    CREATE_DATE_TIME: '',
    CREATE_USER: '',
    END_DATE: '',
    FAX_NUMBER: '',
    MAIL: '',
    MOBILE_MAIL: '',
    MOBILE_NUMBER: '',
    NOTE: '',
    START_DATE: '',
    TELEPHONE_NUMBER: '',
    UPDATE_DATE_TIME: null,
    UPDATE_DATE_TIME2: '',
    UPDATE_USER: '',
    USER_CONFIG: '',
    USER_DISPLAY_NAME: '',
    USER_ID: '',
    USER_NAME_KANA: '',
    USER_NAME_KANJI: '',
    USER_NAME_ROMA: '',
    USER_PASSWORD: '',
    VALID_FLG: '',
    ZIP_CODE: '',
    COMPANY_NAME: ''
  };
  // roleData: any[] = [];
  // selectedRole: any[] = [];

  constructor(private http: AppHttp) {}

  ngOnInit() {
    this.check.rules.MAIL.equalTo = `#${this.formId}USER_ID`;
    this.check.rules.START_DATE.dateLessEqualTo = `.${this.formId}`;
    this.check.rules.USER_PASSWORD_CONFIRM.equalTo = `#${this.formId}USER_PASSWORD`;
  }

  public save() {
    if (!$(`#${this.formId}`).valid()) { return; }
    Messages.confirm('main.save.ask').ok(() => {
      let parm = this.user;
      let uId = encodeURIComponent(this.userId).replace(/\./g, '_ddddd_');
      let action = this.userId ? `/main/user/users/${uId}` : '/main/user/users';
      parm.CREATE_DATE_TIME = moment(parm.CREATE_DATE_TIME).toDate();
      this.http
          .put(this.domain, action, parm)
          .then(o => {
            if (o.success) {
              Messages.info('main.process.success').any(() => {
                this.close();
                this.finish.emit(this.user);
              });
            } else if (o.data && o.data[0]) {
              let validator = $(`#${this.formId}`).validate();
              validator.showErrors(o.data[0]);
              // validator.focusInvalid();
            }
          });
    });
  }

  // 20180502 修正：　Hide 時、無駄のDOMを削除する
  private _showFlag = false ;
  public show(domain, user?, comeInFlag?) {
    this._showFlag = true ;
    setTimeout(()=>{
      this._show(domain,user,comeInFlag) ;
    }, 10) ;
  }


  private _show(domain, user?, comeInFlag?) {
    $(`#${this.formId}`)[0].reset();
    $(`#${this.formId}divHref`).hide();
    if(comeInFlag == "appEdit"){
      $(`#${this.formId}divTime`).hide();
      $(`#${this.formId}divHref`).show();
    }
    setTimeout(() => { $(`#${this.formId}`).validate().resetForm(); }, 100);
    this.domain = domain;
    if (user) {
      let uId = encodeURIComponent(user.USER_ID).replace(/\./g, '_ddddd_');
      this.check.rules.USER_PASSWORD.required = false;
      this.check.rules.USER_PASSWORD_CONFIRM.required = false;
      this.userId = user.USER_ID;
      this.http
          .get(domain, `/main/user/users/${uId}`, null)
          .then(o => {
            if (o.success) {
              this.user = o.data;
              if (this.user.START_DATE) { this.user.START_DATE = moment(this.user.START_DATE).format('YYYY/MM/DD') };
              if (this.user.END_DATE) { this.user.END_DATE = moment(this.user.END_DATE).format('YYYY/MM/DD') };
              $(this.lgModal.nativeElement).modal({backdrop: 'static', keyboard: false});
            }
          });
      $(`#${this.formId}divPwd`).hide();
      $(`#${this.formId}USER_ID`).prop('disabled', 'disabled');
    } else {
      this.userId = '';
      this.check.rules.USER_PASSWORD.required = true;
      this.check.rules.USER_PASSWORD_CONFIRM.required = true;
      $(`#${this.formId}divPwd`).show();
      $(`#${this.formId}USER_ID`).prop('disabled', '');
      $(this.lgModal.nativeElement).modal({backdrop: 'static', keyboard: false});
    }

    // Promise.all([this.http.post(domain, '/node/role/roles', {}), pms])
    //        .then(dt => {
    //           if (dt[0].success) { this.roleData = dt[0].data; }
    //           if (userId && dt[1].success) { this.user = dt[1].data; }
    //           $(this.lgModal.nativeElement).modal({backdrop: 'static', keyboard: false});
    //           console.log(this.user);
    //        });
  }
  close() { 
    $(this.lgModal.nativeElement).modal('hide');

    setTimeout(()=>{
      this._showFlag = false ;
    },10) ;
  }

  changePwd(){
    // this.show('main')
    this.changePW.show();
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/usermanger/usermangeredit/usermangeredit.component.ts